
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trainee-purchase",
      function () {
        return require("private-next-pages/trainee-purchase/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trainee-purchase"])
      });
    }
  